export default "__VITE_ASSET__B0emPF0W__"